import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import demandIcon from '../../assets/images/icons/demand_icon.svg';


function resetFormView() { };

const PubMaticCtv = ({ handlePageViewChange }) => {

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> Pubmatic
                            </Link>
                        </li>
                        <li>Sites</li>
                        <li className="primary">New Site</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Create Site
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Site Type</label>
                                    <p className="sub_text">Please select site type</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Platform * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select a person"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">App Domain *</label>
                                                <Input className='form_control basic ' placeholder='https://' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <Row gutter={16}>
                                                <Col span={18}>
                                                    <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                        <label className="form_label">App Identifier * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="Enter Site/App Identifier"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="form_content_block--group mt-2 pt-1">
                                                        <label className="form_label invisible">checkbox </label>
                                                        <div className="primary_checkbox">
                                                            <Checkbox id="checkboxEnabled" name="checkboxEnabled">
                                                                <span className="form_label">
                                                                    Secure
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">App Store * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Configuration Preferences</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Primary IAB Category *  </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select Primary Category"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Monthly Ad Impressions * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="Select Monthly Ad Impressions"
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="checkboxEnabled" name="checkboxEnabled">
                                                        <span className="form_label">
                                                            COPPA Compliant
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Privacy Policy URL</label>
                                                <Input className='form_control basic ' autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="checkboxEnabled" name="checkboxEnabled">
                                                        <span className="form_label">
                                                            Override Publisher Data
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="checkboxEnabled" name="checkboxEnabled">
                                                        <span className="form_label">
                                                            API Settings
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">
                                                    Content Object
                                                </label>
                                                <Radio.Group className="form_radio equal_space">
                                                    <Radio className="radio_btn" value="Website">
                                                        Pass All
                                                    </Radio>
                                                    <Radio className="radio_btn" value="Inapp">
                                                        Pass PMP
                                                    </Radio>
                                                    <Radio className="radio_btn" value="CTV">
                                                        Don’t Pass
                                                    </Radio>
                                                </Radio.Group>
                                            </div>

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Discard </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Create Site</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PubMaticCtv
